import { createFileRoute } from "@tanstack/react-router";
import { AcceptInvite } from "../../features/invites/components/accept-invite";

/** FR-ACC-04: public; the page itself handles signing in and the wrong account. */
export const Route = createFileRoute("/invite/$token")({
  component: () => <AcceptInvite token={Route.useParams().token} />,
});
